import * as geojson from 'geojson';
import React from 'react';

import {GridFeatureCollection} from './gridGeometry';
import {CellId, GridSpec, Size} from './types';

export interface GridContextValue {
  // ── inputs (passthrough) ──
  projectId: string;
  featureId: number | null; // null when no single feature is selected
  featureGeometry: geojson.Geometry | null;

  // ── ui state ──
  isEnabled: boolean;
  setIsEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  gridSize: Size | null;
  setGridSize: React.Dispatch<React.SetStateAction<Size | null>>;
  /**
   * True while the picker is open. Picker clicks update gridSize without
   * persisting; the LS write happens only when the user hits Create grid,
   * via confirmGridSize().
   */
  isPickingGridSize: boolean;
  confirmGridSize: () => void;
  activeCellId: CellId | null;
  setActiveCellId: React.Dispatch<React.SetStateAction<CellId | null>>;
  reviewedCellIds: Set<CellId>;
  toggleCellReviewed: (id: CellId) => void;
  resetGrid: () => void;

  // ── derived geometry ──
  spec: GridSpec | null;
  featureCollection: GridFeatureCollection | null;
  existingCellIds: Set<CellId> | null;
}

export const GridContext = React.createContext<GridContextValue | null>(null);

export function useGrid(): GridContextValue {
  const ctx = React.useContext(GridContext);
  if (!ctx) throw new Error('useGrid() must be used inside <GridProvider>');
  return ctx;
}
